import React from 'react'
import type { ToolbarProps as MuiToolbarProps } from '@material-ui/core/Toolbar'
import MuiToolbar from '@material-ui/core/Toolbar'

export type ToolbarProps = MuiToolbarProps

const Toolbar = React.forwardRef<HTMLDivElement, ToolbarProps>(function Toolbar(props, ref) {
  return <MuiToolbar ref={ref} {...props} />
})

export default Toolbar
